/**
 * Converts object to query string
 *
 * @param   {Object} data   a map to convert
 * @returns {String}        query string
 */
function mapToQuery(data) {
  const res = [];

  for (const key in data) {
    if (data.hasOwnProperty(key)) { // eslint-disable-line
      res.push(`${key}=${encodeURIComponent(data[key])}`);
    }
  }

  return res.join('&');
}

export default {
  mapToQuery,
};
